import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import { DevLayout } from './components/developers/DevLayout';
import DevelopersIndex from './pages/developers/index';
import GettingStarted from './pages/developers/getting-started';
import Authentication from './pages/developers/authentication';
import SdkQuickstart from './pages/developers/sdk-quickstart';
import CliReference from './pages/developers/cli-reference';
import ApiReference from './pages/developers/api-reference';
import Architecture from './pages/developers/architecture';
import PolicyAuthoring from './pages/developers/policy-authoring';
import BundleCompilation from './pages/developers/bundle-compilation';
import Changelog from './pages/developers/changelog';

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/developers" element={<DevLayout />}>
          <Route index element={<DevelopersIndex />} />
          <Route path="getting-started" element={<GettingStarted />} />
          <Route path="authentication" element={<Authentication />} />
          <Route path="sdk-quickstart" element={<SdkQuickstart />} />
          <Route path="cli-reference" element={<CliReference />} />
          <Route path="api-reference" element={<ApiReference />} />
          <Route path="architecture" element={<Architecture />} />
          <Route path="policy-authoring" element={<PolicyAuthoring />} />
          <Route path="bundle-compilation" element={<BundleCompilation />} />
          <Route path="changelog" element={<Changelog />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
